import script from "./DuplicateDecisionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DuplicateDecisionModal.vue?vue&type=script&setup=true&lang=ts"

import "./DuplicateDecisionModal.vue?vue&type=style&index=0&id=e836f860&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e836f860"]])

export default __exports__